var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message-body"},_vm._l((_vm.messages),function(message,index){return _c('Message',{key:index,attrs:{"is-my":message.autor === _vm.identity,"message":message}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }